<template>
	<div>
		<div class="banxx" style="background:url('/images/yrxm.jpg') no-repeat center center; background-size:cover">
		</div>
		<vue-menu :menu="menu" title="产品服务" :menuWidth="350"></vue-menu>
	</div>
</template>

<script>
	import vueMenu from '../../../components/vue-menu2-product.vue'

	import {
		mapState,
		mapMutations
	} from 'vuex'
	export default {
		data() {
			return {
				menu: []
			}
		},
		components: {
			vueMenu
		},
		created() {
			this.loadData()
		},
		methods: {
			...mapMutations(['setProducts']),
			loadData() {
				this.menu.push({
					title: '新能源汽车',
					children: [{
						title: '中职国赛新能源汽车检测与维修赛项',
						path: '/home/product2/new-energy',
						img: ''
					}, {
						title: '中职国赛汽车机电维修赛项',
						path: '/home/product2/qcjdwxs',
						img: ''
					}, {
						title: '中职国赛车身修理赛项',
						path: '/home/product2/csxls',
						img: ''
					}, {
						title: '高职国赛智能网联汽车技术赛项',
						path: '/home/product2/znwlqcjss',
						img: ''
					}, {
						title: '高职国赛汽车技术赛项',
						path: '/home/product2/qcjss',
						img: ''
					}, {
						title: '中高职其他仿真教学软件',
						path: '/home/product2/qtfzjx',
						img: ''
					}, {
						title: '智能网联汽车仿真教学软件',
						path: '/home/product2/znwlqcfz',
						img: ''
					}, {
						title: '汽车1+X仿真教学软件',
						path: '/home/product2/qc1X',
						img: ''
					}, {
						title: 'VR/AR仿真教学软件',
						path: '/home/product2/vrarfz',
						img: ''
					}]
				})
				this.$http.get('product/GetProduct.do').then(res => {
					if (res.data) {
						this.setProducts(res.data)
						res.data.forEach(item => {
							if (!this.menu.find(item2 => item2.title == item.category)) {
								this.menu.push({
									title: item.category,
									children: [{
										title: item.name,
										path: '/home/product2/details/' + item.id,
										img: item.imgUrl
									}]
								})
							} else {
								let a = this.menu.find(item2 => item2.title == item.category)
								a.children.push({
									title: item.name,
									path: '/home/product2/details/' + item.id,
									img: item.imgUrl
								})
							}
						})
					}
					this.menu.push({
						title: '技能大赛',
						children: [{
							title: '中药技能大赛',
							path: '/home/product2/zyjnds2',
							img: ''
						}]
					}, {
						title: '墨影数字教师平台',
						children: [{
							title: '墨影数字教师平台',
							path: '/home/product2/myszjspt',
							img: ''
						}]
					})
				})
			}
		}
	}
</script>

<style scoped>
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	hr,
	dt,
	dd,
	dl {
		font-size: 14px;
		margin: 0;
		padding: 0;
		font-weight: normal;
	}

	.banxx {
		height: 150px;
	}
</style>